import React from 'react'
import DSLoadTest from '../components/test/DSLoadTest'

const DSLoadTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <DSLoadTest />
    </div>
  )
}

export default DSLoadTestPage